export default __webpack_public_path__ + "static/portfolio-img-1-c7ecc548d75a30e15e8f6f6497149911.png";